/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      developmentPlans {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      developmentPlans {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      developmentPlans {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const createDevelopmentPlan = /* GraphQL */ `
  mutation CreateDevelopmentPlan(
    $input: CreateDevelopmentPlanInput!
    $condition: ModelDevelopmentPlanConditionInput
  ) {
    createDevelopmentPlan(input: $input, condition: $condition) {
      id
      name
      version
      userID
      progress_percent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const updateDevelopmentPlan = /* GraphQL */ `
  mutation UpdateDevelopmentPlan(
    $input: UpdateDevelopmentPlanInput!
    $condition: ModelDevelopmentPlanConditionInput
  ) {
    updateDevelopmentPlan(input: $input, condition: $condition) {
      id
      name
      version
      userID
      progress_percent
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const deleteDevelopmentPlan = /* GraphQL */ `
  mutation DeleteDevelopmentPlan(
    $input: DeleteDevelopmentPlanInput!
    $condition: ModelDevelopmentPlanConditionInput
  ) {
    deleteDevelopmentPlan(input: $input, condition: $condition) {
      id
      name
      version
      userID
      progress_percent
      createdAt
      updatedAt
      __typename
    }
  }
`;
